module.exports = __webpack_public_path__ + "assets/img/5-mobile.7d360ab9.png";